







import {Component, Vue} from "vue-property-decorator";
import AuthService from "@/services/AuthService";

@Component
export default class Login extends Vue {
    public created() {
        AuthService.checkForAccessTokenInUrl(this.$route.hash);

        if (AuthService.isLoggedIn()) {
            window.location.href = "/app";
        } else {
            this.login();
        }
    }

    public login() {
        AuthService.handleLogin();
    }
}
